import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/cierreProyecto';
import CierreProyecto from './cierreProyectoForm';

const ms2p = (state) => {
  return {
    ...state.proyecto_cierre_proyecto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CierreProyecto);
